import { withCompInfo } from '../../core/withCompInfo'
import {
	SelectionTagsListDefinition,
	SelectionTagsListProps,
	SelectionTagsListCSSVars,
	SelectionTagsListCssCarmiData,
	SelectionTagsListAlignmentProps,
} from './types'

export const props = withCompInfo<SelectionTagsListProps, SelectionTagsListDefinition>(
	['compData', 'compProps'],
	({ compData, compProps }) => {
		const { isDisabled, required } = compProps
		const { options, value } = compData

		return { options, value, isDisabled, required }
	}
)

export const css = withCompInfo<SelectionTagsListCSSVars, SelectionTagsListDefinition, SelectionTagsListCssCarmiData>(
	['compProps'],
	({ compProps }, carmiProps) => {
		const { direction } = compProps

		let alignment = '' as SelectionTagsListAlignmentProps

		if (compProps.alignment === 'left') {
			if (direction === 'rtl') {
				alignment = 'flex-end'
			} else {
				alignment = 'flex-start'
			}
		} else if (compProps.alignment === 'right') {
			if (direction === 'rtl') {
				alignment = 'flex-start'
			} else {
				alignment = 'flex-end'
			}
		} else {
			alignment = compProps.alignment
		}

		return {
			'--direction': direction,
			'--alignment': alignment,
			'--fnt': carmiProps['--fnt'],
		}
	}
)
